import React from 'react'
import reactStamp from 'react-stamp'
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import BirthDateField from './BirthDateField'

import './register.css'

export default reactStamp(React).compose({

    init(){
        this._handleSubmit = this._handleSubmit.bind(this);
        this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
        this.handleDiscard = this.handleDiscard.bind(this);
        this.handleGenderChange = this.handleGenderChange.bind(this);
        this.handleBirthDateChange = this.handleBirthDateChange.bind(this);
    },

    state: {
        fieldNames: {
            email: "",
            password: "",
            firstName: "",
            familyName: "",
            birthDate: "",
            gender: "male",
            addressLine: "",
            city: "",
            state: "",
            district: "",
            postalCode: "",
            country: "",
            phoneNumber: ""
        },
        err: {}
    },

    componentWillReceiveProps(nextProps){
        let _state = this.state;
        _state.err["email"] = nextProps.emailError;
        this.setState(_state);
    },

    _handleSubmit(e){
        e.preventDefault();
        let err = false;
        let _state = this.state;
        Object.keys(_state.fieldNames).forEach((key, index) => {
            let _value = _state.fieldNames[key];
            if (_value != "" && _value !== undefined) {
                switch (key) {
                    case "email":
                    {
                        if (!this.validateEmail(_value)) {
                            _state.err[key] = 'Email address is not valid';
                        }
                    }
                }
                _state.err[key] = '';
            } else {
                _state.err[key] = 'Please, fill this field';
            }
        });
        //console.log(_state.err);
        Object.keys(_state.err).forEach((key, index) => {
            if (_state.err[key] != "") {
                err = true;
            }
        });
        this.setState(_state);

        if (!err) {
            this.props.handleSubmit(
                this.state.fieldNames.email,
                this.state.fieldNames.password,
                this.state.fieldNames.firstName,
                this.state.fieldNames.familyName,
                this.state.fieldNames.gender,
                this.state.fieldNames.addressLine,
                this.state.fieldNames.city,
                this.state.fieldNames.state,
                this.state.fieldNames.district,
                this.state.fieldNames.postalCode,
                this.state.fieldNames.country,
                this.state.fieldNames.phoneNumber,
                this.state.fieldNames.birthDate
            );
        }
    },

    handleDiscard(){
        Object.keys(this.state.fieldNames).forEach((key, index) => {
            this.state.fieldNames[key] = ""
        });
        this.state.fieldNames["gender"] = "male";
        this.setState(this.state);
    },

    handleTextFieldChange(e, field) {
        let _state = this.state;
        let _value = e.target.value;
        _state.fieldNames[field] = _value;


        if (_value != "" && _value !== undefined) {
            switch (field) {
                case "email":
                {
                    if (!this.validateEmail(_value)) {
                        _state.err[field] = 'Email address is not valid';
                    } else {
                        _state.err[field] = '';
                    }
                    break;
                }
                default:
                    _state.err[field] = '';
            }

        } else {
            _state.err[field] = 'Please, fill this field';
        }
        this.setState(_state);
    },

    handleGenderChange(event, index, value) {
        let _state = this.state;
        console.log(value);
        _state.fieldNames["gender"] = value;
        this.setState(_state);
    },

    handleBirthDateChange(date){
        let _state = this.state;
        console.log(date);
        _state.fieldNames["birthDate"] = date;
        _state.err["birthDate"] = '';
        this.setState(_state);
    },

    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },

    render()
    {
        const styles = {
            button: {
                height: 50,
                width: 220,
                marginRight: 10,
                marginLeft: 10
            },
            selectField: {
                display: "block",
                width: "70%",
                margin: "auto",
                "text-align": "left"
            }
        };

        const actions = [
            <RaisedButton
                label="Create account"
                primary={true}
                style={styles.button}
                onTouchTap={this._handleSubmit}
            />
        ];

        const textFields = [];

        for (let fieldName in Object.keys(this.state.fieldNames)) {


            const items = [
                <MenuItem key={"male"} value={"male"} primaryText="Male"/>,
                <MenuItem key={"female"} value={"female"} primaryText="Female"/>
            ];

            let name = (Object.keys(this.state.fieldNames)[fieldName]);
            let realFieldName = name;
            name = name.match(/[A-Z][a-z]+/g) != undefined ? name.match(/([a-z]+)|([A-Z][a-z]+)/g).join(' ') : name;
            name = name.charAt(0).toUpperCase() + name.slice(1);

            let newItem;
            if (realFieldName == "gender") {
                newItem = <SelectField
                    value={this.state.fieldNames.gender}
                    onChange={this.handleGenderChange}
                    floatingLabelText="Choose gender"
                    floatingLabelFixed={true}
                    style={styles.selectField}
                >
                    {items}
                </SelectField>
            } else if (realFieldName == "birthDate") {
                newItem = <BirthDateField
                    err={this.state.err[realFieldName]}
                    onsetDate={this.state.fieldNames[realFieldName]}
                    onDateChange={this.handleBirthDateChange}
                />
            } else {
                newItem = <TextField
                    key={fieldName}
                    className="register-textfield"
                    floatingLabelText={name}
                    floatingLabelFixed={true}
                    value={this.state.fieldNames[realFieldName]}
                    type={(realFieldName=="password") ? "password" : "text"}
                    onChange={(e)=>this.handleTextFieldChange(e, realFieldName)}
                    errorText={this.state.err[realFieldName]}
                />
                
            }
            textFields.push(newItem);

        }

        const customContentStyle = {
            minWidth: '300px',
            maxWidth: '600px',
        };

        let classes = '';

        if (this.props.mobile) {
            classes = "register-form-mobile"
        } else {
            classes = "register-form"
        }

        return (
            <div>
                <form className={classes}>
                    {textFields}
                </form>
                {actions}
            </div>
        );
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Register/RegisterForm.js
 **/